import Anchor from '../../anchor/src/index.vue';
import { getTimeStampForCache } from '../../../../utils/common';

export default {
    props: {
        CITY: {
            default: () => {
                return {};
            },
            type: Object
        },
        ENV: {
            default: 'anjuke',
            type: String
        },
        biz: {
            default: 'esf',
            type: String
        },
        value: {
            default: () => {
                return {};
            },
            type: Object
        },
        isCacheable: {
            default: false,
            type: Boolean
        }
    },
    name: 'EsfPcFangyuanFooter',
    serverCacheKey: (props) => {
        if (!props.isCacheable) return false;
        return `${props.biz}_${props.CITY.id}_${props.CITY.alias}_${getTimeStampForCache()}_${props.version || ''}`;
    },
    components: {
        Anchor
    },
    computed: {
        links() {
            return (this.value && this.value.links) || [];
        },
        bottomLinks() {
            return (this.value && this.value.bottomLinks) || null;
        },
        footer() {
            return (this.value && this.value.footer) || null;
        },
        cooperative() {
            return (this.value && this.value.cooperative) || {};
        },
        year() {
            const myDate = new Date();
            return myDate.getFullYear();
        }
    },
    data() {
        return {
            seoCur: '0',
            seoCur2: '0',
            name: '',
            timer: null
        };
    },
    methods: {
        setSeoCur(index) {
            this.seoCur = index;
        },
        setSeoCur2(index) {
            this.seoCur2 = index;
        },
        onOtherClick(item) {
            clearTimeout(this.timer);
            this.timer = null;
            this.name = item;
            this.timer = setTimeout(() => {
                this.name = '';
                clearTimeout(this.timer);
                this.timer = null;
            }, 3000);
        }
    }
};
